import type { MeetingData, MeetingPointPayloadData } from '../../types';

import { AxiosError } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';

import { axiosClient } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';

type Payload = {
  companyID: number;
  meetingID: number;
  body: MeetingPointPayloadData;
};

export const addMeetingPoint = async ({ companyID, meetingID, body }: Payload): Promise<{ data: MeetingData }> => {
  const { data } = await axiosClient.post<{ data: MeetingData }>(
    `/companies/${companyID}/meetings/${meetingID}/meeting-points`,
    body,
  );
  return data;
};
type UseAddMeetingPointOptions = {
  config?: Partial<UseMutationOptions<{ data: MeetingData }, AxiosError<{ message: string }>, Payload>>;
  postSuccess?: (meetingData: MeetingData) => void;
};

export const useAddMeetingPoint = ({ config, postSuccess }: UseAddMeetingPointOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.message,
      });
    },
    onSuccess: async (meetingData, params) => {
      await queryClient.invalidateQueries({
        queryKey: ['meetings'],
      });
      await queryClient.invalidateQueries({
        queryKey: ['meeting-details', params.companyID, params.meetingID],
      });
      await queryClient.invalidateQueries({
        queryKey: ['meeting-points', params.companyID, params.meetingID],
      });
      toaster.success({
        message: 'Added Successfully',
        description: 'Meeting Point Added Successfully',
      });
      postSuccess?.({ ...meetingData.data });
    },
    ...config,
    mutationFn: addMeetingPoint,
  });
};
